// extracted by mini-css-extract-plugin
export default {"wrapper":"GiziList_wrapper__on5vx","font-title":"GiziList_font-title__jCzW8"};